import React from 'react';
import { useNavigate } from 'react-router-dom';
import SearchBar from '../../components/navigation/SearchBar';
import PracticesTable from '../../components/practicesTable/PracticesTable';
import WelcomeBanner from '../../components/WelcomeBanner';
import { SearchProvider } from '../../contexts/SearchContext';
import { PracticesListProvider } from '../../providers/practices/PracticesListProvider';
import { useUser } from '../../providers/UserProvider';

const PracticesOverview: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useUser();

    if (!user?.database.data.isAdmin) {
        navigate('/home');
    }

    return (
        <SearchProvider storageKey="home">
            <div className="flex flex-col h-full w-full">
                {/* Top left welcome message */}
                <WelcomeBanner forcedTitle="All doctors" />

                {/* Top bar with search and add button */}
                <div className="flex items-center justify-between w-full px-8 mt-40">
                    <div className="flex items-center gap-4">
                        <SearchBar placeholder="Search by first or last name" />
                    </div>
                </div>

                <PracticesListProvider>
                    <div className="flex-1 min-h-0 flex flex-col w-full">
                        <PracticesTable />
                    </div>
                </PracticesListProvider>
            </div>
        </SearchProvider>
    );
};

export default PracticesOverview;
